import React from 'react';
import '../../styles/components/common/TimeRangePicker.css';

interface TimeRangePickerProps {
  startTime: string;
  endTime: string;
  onStartTimeChange: (time: string) => void;
  onEndTimeChange: (time: string) => void;
  startLabel?: string;
  endLabel?: string;
  startInputClassName?: string;
  endInputClassName?: string;
  startError?: string;
  endError?: string;
  isSingleTime?: boolean;
}

const TimeRangePicker: React.FC<TimeRangePickerProps> = ({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
  startLabel = 'From',
  endLabel = 'To',
  startInputClassName = '',
  endInputClassName = '',
  startError,
  endError,
  isSingleTime = false
}) => {
  return (
    <div className={`time-picker-container ${isSingleTime ? 'single-time' : 'time-range'}`}>
      <div className="time-field">
        <div className="label-with-error">
          <label>{startLabel}</label>
          {startError && <span className="inline-error">{startError}</span>}
        </div>
        <input
          type="time"
          value={startTime}
          onChange={(e) => onStartTimeChange(e.target.value)}
          className={`time-input ${startInputClassName}`}
        />
      </div>
      
      {!isSingleTime && (
        <div className="time-field">
          <div className="label-with-error">
            <label>{endLabel}</label>
            {endError && <span className="inline-error">{endError}</span>}
          </div>
          <input
            type="time"
            value={endTime}
            onChange={(e) => onEndTimeChange(e.target.value)}
            className={`time-input ${endInputClassName}`}
          />
        </div>
      )}
    </div>
  );
};

export default TimeRangePicker; 